import React from "react";
import { ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyToTransformHealthcare() {
  return <section data-section-id="236821" id="ready-to-switch-to-eco-packaging" className="dark bg-background text-foreground relative isolate overflow-hidden py-24 sm:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_top_left,_var(--tw-gradient-stops))] from-primary/10 via-background to-background"></div>
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_bottom_right,_var(--tw-gradient-stops))] from-accent/10 via-transparent to-transparent"></div>

      {}
      <div className="absolute inset-0 -z-10 opacity-[0.08] mix-blend-multiply pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }}></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 flex flex-col items-center text-center">
        <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter mb-6 max-w-4xl text-balance uppercase">
          Make the Switch to Eco-Packaging
        </h2>
        
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 font-default text-balance">
          Join the movement of sustainable food service. From sturdy kraft wraps to biodegradable bags, PackLux delivers quality without compromise.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 w-full sm:w-auto">
          <Button asChild size="lg" className="h-14 px-10 text-lg rounded-md shadow-md transition-all hover:bg-primary/90 hover:-translate-y-0.5 w-full sm:w-auto font-default">
            <Link to="/BulkCustomizationPage">Bulk Ordering</Link>
          </Button>
          
          <Button asChild variant="ghost" className="text-base h-14 px-6 rounded-md border border-border hover:bg-accent/20 hover:text-accent-foreground group w-full sm:w-auto font-mono">
            <Link to="/ShopPage">
              Request Sample Kit
              <ChevronRight className="ml-2 size-5 transition-transform group-hover:translate-x-1 text-primary" />
            </Link>
          </Button>
        </div>

        <div className="mt-16 flex flex-wrap justify-center items-center gap-8 opacity-60 grayscale hover:grayscale-0 transition-all duration-500">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669361/img/certified_compostable_logo.png" alt="Certified Compostable" className="h-8 w-auto" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669361/img/fsc_pulp_logo.png" alt="FSC Sourced" className="h-8 w-auto" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669361/img/eco_safe_seal.png" alt="Food Safe Seal" className="h-8 w-auto" />
        </div>
      </div>
    </section>;
}